import { render } from "./ErrorBox.vue?vue&type=template&id=7454a7f4&ts=true"
import script from "./ErrorBox.vue?vue&type=script&lang=ts"
export * from "./ErrorBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__